import { styled } from '@mui/system';
import COLORS from '../../../theme/Colors';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export const StyledOption = styled('option')({
  fontSize: '18px',
});

export const MenuContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width:'100%',
  maxHeight:'15vh',
  backgroundColor:'white',
  border:`1px solid ${COLORS.secondary}`,
  borderTopWidth:0,
  borderRadius:'5px',
  margin:'1px'
});